import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LabelStandAlone as Label } from '../../../components/label/labelStandAlone';
import { getMaxLabelSize } from '../../../utils/getMaxLabelSize/getMaxLabelSize.utils';
// styles
import { AdditionalInfoWrapperStyled, LabelWrapperStyled } from '../input.styled';
import { LABEL_TYPE } from '../types/inputTheme';
import { getFontSize } from '../utils/fontSize.utils';
export const LabelStandAlone = (props) => {
    const [maxLabelSize, setMaxLabelSize] = React.useState(undefined);
    const proceed = !!props.label &&
        !!props.inputId &&
        props.styles?.[props.state]?.label?.type !== LABEL_TYPE.OUTLINED;
    React.useEffect(() => {
        setMaxLabelSize(getMaxLabelSize(proceed, props.inputId));
        window.addEventListener('resize', () => {
            setMaxLabelSize(getMaxLabelSize(proceed, props.inputId));
        });
        return () => {
            window.removeEventListener('resize', () => {
                setMaxLabelSize(getMaxLabelSize(proceed, props.inputId));
            });
        };
    }, []);
    return props.label ? (_jsxs(LabelWrapperStyled, { "$maxLabelSize": maxLabelSize, "$placeholder": props.placeholder, leftExtraStyles: props.leftExtraStyles, state: props.state, styles: props.styles?.[props.state], topExtraStyles: props.topExtraStyles, children: [_jsxs(Label, { asteriskColor: props.styles?.[props.state]?.asterisk?.color, asteriskVariant: getFontSize(props.state, 'font_variant', 'asterisk', props.styles, props.placeholder), asteriskWeight: props.styles?.[props.state]?.asterisk?.font_weight, color: props.styles?.[props.state]?.label?.color, id: props.id, inputId: props.inputId, required: props.required, textVariant: getFontSize(props.state, 'font_variant', 'label', props.styles, props.placeholder), weight: props.styles?.[props.state]?.label?.font_weight, ...props.label, children: [props.label.content, !props.required && props.secondaryLabel ? props.secondaryLabel : null] }), _jsx(AdditionalInfoWrapperStyled, { styles: props.styles?.[props.state], children: props.additionalInfo })] })) : null;
};
//# sourceMappingURL=label.js.map